// Extracted from shared/entityPresentation.ts; behavior and declaration bodies preserved.
import type { ModelDocument } from "../shared/contracts.js";
import { selectedPrimaryKeys } from "./keySelection.js";
export const fieldKinds = ['attribute', 'column', 'property', 'semanticField', 'measure'];
export function entityFields(document: ModelDocument, objectId: string) {
  const object = document.objects.find(o => o.objectId === objectId);
  // Authorization has already scoped this document; never cross its representation boundary.
  const children = document.objects.filter(o => o.ownerObjectId === objectId && o.representationId === object?.representationId);
  const keys = children.filter(o => o.kind === 'key');
  // Array.sort is stable: missing or equal ordinals keep their stored order. Display never reorders keys first.
  const fields = [...new Map(children.filter(o => fieldKinds.includes(o.kind)).map(o => [o.objectId, o])).values()].sort((a,b)=>(a.ordinal ?? 0)-(b.ordinal ?? 0));
  const primaryKeys = selectedPrimaryKeys(keys);
  return { fields, keys, primary: primaryKeys.length === 1 ? primaryKeys[0] : undefined, primaryKeys };
}
